import React from 'react'
import { useTranslation } from 'react-i18next'
import "./sendDashboards.scss"

function SendDashboards() {

  const { t } = useTranslation()

  return (

    <div className='container-send-dashboards'>
      <div className="texts-send-dashboards">
        <h1>{t("publish_and_share.send_dashboards.title")}</h1>
        <p>{t("publish_and_share.send_dashboards.section_text")}</p>
      </div>
    </div>
  )
}


export default SendDashboards